<div class="departments" *ngIf="_ds.departments_list">
    <a [title]="depart.name" routerLink="/department/{{depart.slug_name}}"
         [title]="depart.name"
        *ngFor="let depart of _ds.departments_list">
        <div class="dp-img-box p-card-i">
            <img ngOptimizedImage width="89" height="89" [src]="depart?.icon" alt="category.name"
                loading="lazy">
        </div>
        <span class="d-item-title" >{{depart.name}}</span>
    </a>
    
</div>
<!--  -->